import React from 'react';
//react-redux comm
import { connect } from 'react-redux';
import {  } from '../../_actions';

import ViewHeader from './view-header';
import ViewContent from './view-validation-content';

// styling
import './style.css';

//import { appHelpers } from '../../_helpers';

class IATAValidationPage extends React.Component {
    render() {
        return (
            <div className="view">
                <ViewHeader/>
                <ViewContent/>
            </div>
        )
    }

}

function mapStateToProps(state, ownProps) {
    const { authentication } = state;
    const { user } = authentication;
    return user;
}

export default connect(mapStateToProps)(IATAValidationPage);



// WEBPACK FOOTER //
// ./src/views/iataValidation/index-validation.js